if (!customElements.get('appear-animate-single')) {
  class AppearAnimateSingle extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      if (!window.appearAnimate && this.dataset.force == undefined) return;
      Motion.inView(this, (info) => {
        this.showElement()
      });
    }

    showElement() {
      if(!this.dataset.immediate) {
        setTimeout(() => this.classList.add('appear'), 500);
      } else {
        this.classList.add('appear');
      }
    }
  };
  
  customElements.define('appear-animate-single', AppearAnimateSingle);
}

if (!customElements.get('appear-animate-list')) {
  class AppearAnimateList extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      if(!window.appearAnimate) return;
      this.delay = this.dataset.delay ? parseFloat(this.dataset.delay): 0.1;
      this.items = this.querySelectorAll('.appear-animate-item-in-list');
      Motion.inView(this, (info) => {
        this.classList.add('start');
        this.showElements();
      });
    }

    showElements() {
      const hasNativeSlider = this.querySelector('.slider.slider--mobile, .slider.slider--tablet');
      const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
      const shouldDisableTranslate = hasNativeSlider && isTouchDevice;

      if (shouldDisableTranslate) {
        this.classList.add('appear-no-translate');
      }

      const keyframes = shouldDisableTranslate
        ? { opacity: [0, 1] }
        : { transform: ['translateY(3rem)', 'translateY(0)'], opacity: [0, 1] };

      // Apply the final state first and let `fill: backwards` hold the start keyframe,
      // so no frame is painted between the animation ending and the final style applying.
      this.items.forEach((item, index) => {
        item.classList.add('done');
        item.animate(keyframes, { delay: index * this.delay * 1000, duration: 500, easing: 'cubic-bezier(.03,.93,.97,1)', fill: 'backwards' });
      });
    }

    reset() {
      if(!window.appearAnimate) return;
      this.items = this.querySelectorAll('.appear-animate-item-in-list:not(.done)');
      this.showElements();
    }
  };
  
  customElements.define('appear-animate-list', AppearAnimateList);
}
